package music.jammers.client.shared.component

import kotlinx.coroutines.CoroutineExceptionHandler
import music.limasoul.client.shared.navigation.Navigation
import music.limasoul.client.shared.navigation.Router
import music.limasoul.shared.network.domain.model.AuthException
import kotlin.coroutines.AbstractCoroutineContextElement
import kotlin.coroutines.CoroutineContext

inline fun customExceptionHandler(
    router: Router,
    crossinline handler: (CoroutineContext, Throwable) -> Unit,
): CoroutineExceptionHandler =
    object : AbstractCoroutineContextElement(CoroutineExceptionHandler), CoroutineExceptionHandler {
        override fun handleException(context: CoroutineContext, exception: Throwable) {
            when (exception) {
                is AuthException -> router.navigateTo(Navigation.Login)
                else             -> handler.invoke(context, exception)
            }
        }
    }